import React, { useEffect, useRef, useState } from 'react';

import { removeItem } from 'utils/utils'

import Presenter from 'components/presenters/signup/TermsAndConditionCheckModal';
import TermsAndConditionModal from 'components/presenters/signup/TermsAndConditionModal';
import PrivatePolicyModal from 'components/presenters/signup/PrivatepolicyModal';

export default function TermsAndConditionCheckModal({
    onComplete,
    setTermsAndConditionCheckModalVisible
}) {
    const [checkItemsData, setCheckItemsData] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);
    const [checkItems, setCheckItems] = useState([]);
    const [ termsAndConditionValid, setTermsAndConditionValid ] = useState(false);
    const [onSignupComplete, setOnSignupComplete] = useState();

    const [ termsAndConditionVisible, setTermsAndConditionVisible ] = useState(false);
    const [ privatePolicyVisible, setPrivatePolicyVisible ] = useState(false);

    const modalRef = useRef(null);

    const checkValid = () => {
        if(checkItems.includes(1) && checkItems.includes(2))
        {
            return true;
        }
        return false;
    }

    const handleAllChecked = (e) => {
        const { checked } = e.target;
        
        if(!checked)
        {
            setCheckItems([]);
        }
        else 
        {
            const checkItemList = [];
            for(let i = 0; i < checkItemsData.length; ++i)
            {
                checkItemList.push(checkItemsData[i]['id']);
            }
            setCheckItems(checkItemList);
        }
        setIsSelectAll(checked);
    }

    const handleOutSideClick = (e) => {
        if(modalRef.current && !modalRef.current.contains(e.target))
        {
            setTermsAndConditionCheckModalVisible(false);
        }
    }   

    const handleSingleClick = (e, id) => {
        const { checked } = e.target;
        if(!checked)
        {
            const index = checkItems.indexOf(id)
            const reloadCheckItems = removeItem(checkItems, index);
           
            setCheckItems(reloadCheckItems);
            return;
        }
        setCheckItems([...checkItems, id]);
    }

    useEffect(() => {
        setCheckItemsData([
            {
                id: 1,
                description: '[필수] 서비스 이용 약관 동의',
                openModal: () => setTermsAndConditionVisible(true),
            },
            {
                id: 2,
                description: '[필수] 개인정보 수집 및 이용 동의',
                openModal: () => setPrivatePolicyVisible(true),
            },
            {
                id: 3,
                description: '이벤트 및 푸시알림 동의 (선택)',
            }
        ])
    }, [])


    /* eslint-disable react-hooks/exhaustive-deps */ 
    useEffect(() => {
        const isValid = checkValid();
        
        if(isValid && onComplete)
        {
            setOnSignupComplete(() => () => onComplete(checkItems));
        }
        setTermsAndConditionValid(isValid);
        if(isSelectAll && checkItems.length !== 3)
        {
            
            setIsSelectAll(false);
        }
        if(!isSelectAll && checkItems.length === 3)
        {
            setIsSelectAll(true);
        }
    }, [checkItems])

    useEffect(() => {
        if(isSelectAll)
        {
            setTermsAndConditionValid(true);
        }
        else
        {
            const isValid = checkValid()
            setTermsAndConditionValid(isValid);
        }
    }, [isSelectAll])

    return (
        <>
            <Presenter 
                onAllChecked={handleAllChecked}
                checkItemsState={checkItemsData}
                isSelectAll={isSelectAll}
                onSingleCheck={handleSingleClick}
                checkItems={checkItems}
                termsAndConditionValid={termsAndConditionValid}
                onSignupComplete={onSignupComplete}
                onClickOutSide={handleOutSideClick}
                modalRef={modalRef}
            />
            <TermsAndConditionModal visible={termsAndConditionVisible} onClose={() => setTermsAndConditionVisible(false)}/>
            <PrivatePolicyModal visible={privatePolicyVisible} onClose={() => setPrivatePolicyVisible(false)}/>
        </>
    )
}